import { useEffect } from "react";

const ORIGIN = process.env.REACT_APP_BACKEND_URL;

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Per-route social/SEO tags. Static defaults live in public/index.html
// (read by WhatsApp/LinkedIn crawlers); this hook refines them for
// JS-capable crawlers and the browser tab.
export function useSeo({ title, description, path, image = "/og-image.png", noindex = false }) {
  useEffect(() => {
    const url = `${ORIGIN}${path}`;
    const img = `${ORIGIN}${image}`;
    document.title = title;
    upsertMeta("name", "description", description);
    if (noindex) upsertMeta("name", "robots", "noindex");
    else document.head.querySelector('meta[name="robots"][content="noindex"]')?.remove();
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", img);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, path, image, noindex]);
}
